import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {CountShapesModel} from '../../../../../models/questions/subModels/countShapes.model';
import {ShapeNameFromImageModel} from '../../../../../models/questions/subModels/shapeNameFromImage.model';
import {EvoListSelectorService} from '../../../../../shared/modals/evo-list-selector/evo-list-selector.service';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-shape-name-from-image',
  templateUrl: './evo-shape-name-from-image.component.html',
  styleUrls: ['./evo-shape-name-from-image.component.css']
})
export class EvoShapeNameFromImageComponent implements OnInit {

  Enums = Enums;
  QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new ShapeNameFromImageModel();

  constructor(private selectorSv: EvoListSelectorService) { }

  ngOnInit() {
  }

  castedQuestion(): ShapeNameFromImageModel {

    return <ShapeNameFromImageModel>this.question;
  }

  removeShape(index: number) {
    if (index < this.castedQuestion().model.possibleAnswers.length) {
      this.castedQuestion().model.possibleAnswers.splice(index, 1);
    }
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.shapeNameFromImage) {
        return true;
      }
    }

    return false;
  }

  showSelector() {
    this.selectorSv.showList(Enums.Shapes.list(), this.castedQuestion().model.possibleAnswers).subscribe((item) => {
      if (item) {
        this.castedQuestion().model.possibleAnswers.push(item);
      }
    });
  }

}
